<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6.72607" cy="6" r="6" :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      default: '13',
      type: String
    },
    height: {
      default: '12',
      type: String
    },
    color: {
      default: '#2F7F91',
      type: String
    }
  }
}
</script>

<style></style>
